module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-15.02fda19c.png";